import { render } from "./OrgBookingRedirect.vue?vue&type=template&id=06c3a135&ts=true"
import script from "./OrgBookingRedirect.vue?vue&type=script&lang=ts"
export * from "./OrgBookingRedirect.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__